import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  constructor(private http: HttpClient) { }

  getCompanies(query?) {
    if (query) {
      return this.http.get(`/companies/?${query}`);
    }
    return this.http.get(`/companies/`);
  }

  getCompany(id) {
    return this.http.get(`/companies/${id}`);
  }

  getCompanyUsers(id) {
    return this.http.get(`/companies/${id}/users`);
  }

  getCompanyManagers() {
    return this.http.get(`/companies/managers?fetch=all`);
  }

  updateRepresentative(companyId, userId, status) {
    return this.http.put(`/companies/${companyId}/users/${userId}`, { is_company_representative: status });
  }

  updateCompanyManagers(companyId, managers) {
    return this.http.put(`/companies/${companyId}/managers`, managers);
  }

  updateHalRegions(companyId, payload) {
    return this.http.put(`/companies/${companyId}/halregions`, payload);
  }

  getPackages() {
    return this.http.get('/clusters/products');
  }

  getHalRegions() {
    return this.http.get(`/region/halregion`);
  }

  removeCompany(companyID: number) {
    return this.http.delete('/companies/' + companyID).pipe(map(results => true));
  }
  getAllManagers(){
    return this.http.get(`/companies/managers?fetch=all`)
  }

  getSubsidiaryCompanies(id) {
    return this.http.get(`/companies/${id}/subsidiary`);
  }
}
